export const setPstnValue = (phoneNumbers: any) => {
  const phoneNumberItem = phoneNumbers.map((phone: any) => phone.phone);
  return phoneNumberItem;
};
